export const badgeTypes = {
	default: 'default',
	primary: 'primary',
	secondary: 'secondary',
	success: 'success',
	info: 'info',
	danger: 'danger',
	warning: 'warning',
};
